"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var merchant = _interopRequireWildcard(require("@/api/merchant"));
var _vuex = require("vuex");
var _keyword = _interopRequireDefault(require("../../../components/base/keyword"));
var _toolsValidate = require("@/utils/toolsValidate");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var _default = exports.default = {
  name: 'CreatClassify',
  components: {
    Keyword: _keyword.default
  },
  props: {
    merId: {
      type: Number,
      default: 0
    },
    // true是详情，false是编辑
    isDisabled: {
      type: Boolean,
      default: false
    },
    // 操作类型，编辑、详情
    handleType: {
      type: String,
      default: ''
    },
    indexKey: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    var _this2 = this;
    var validateVal = function validateVal(rule, value, callback) {
      if (_this2.labelarr.length === 0) {
        callback(new Error('请输入后回车'));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      loading: false,
      loadingFrom: false,
      rules: {
        name: [{
          required: true,
          message: '请输入商户名称',
          trigger: 'blur'
        }],
        categoryId: [{
          required: true,
          message: '请选择商户分类',
          trigger: 'change'
        }],
        typeId: [{
          required: true,
          message: '请选择店铺类型',
          trigger: 'change'
        }],
        realName: [{
          required: true,
          message: '请输入商户姓名',
          trigger: 'blur'
        }],
        labelarr: [{
          required: true,
          validator: validateVal,
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          validator: _toolsValidate.validatePhone,
          trigger: 'blur'
        }],
        handlingFee: [{
          required: true,
          message: '请输入手续费',
          trigger: 'blur'
        }],
        sliderImages: [{
          required: true,
          message: '请上传资质图片',
          type: 'array',
          trigger: 'change'
        }]
      },
      dataForm: {
        categoryId: null,
        handlingFee: 0,
        isRecommend: false,
        isSelf: false,
        isSwitch: false,
        keywords: '',
        name: '',
        phone: '',
        productSwitch: false,
        qualificationPicture: '',
        realName: '',
        remark: '',
        sort: 0,
        typeId: null,
        sliderImages: [],
        id: 0,
        jeequanMchNo: ''
      },
      isCn: true,
      labelarr: [],
      merImg: require('@/assets/imgs/dianpu.png')
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['merchantClassify', 'merchantType'])),
  watch: {
    merId: {
      handler: function handler(val) {
        if (val > 0) this.onInfo();
      },
      deep: true
    },
    'dataForm.name': function dataFormName(val) {
      var pattern = new RegExp("[\u4E00-\u9FA5]+");
      var pattern2 = new RegExp('[A-Za-z]+');
      if (pattern.test(val)) {
        this.isCn = true;
      } else if (pattern2.test(val)) {
        this.isCn = false;
      }
    }
  },
  mounted: function mounted() {
    if (!this.merchantClassify.length) this.$store.dispatch('merchant/getMerchantClassify');
    if (!this.merchantType.length) this.$store.dispatch('merchant/getMerchantType');
    if (this.merId > 0) this.onInfo();
  },
  methods: {
    // 详情中点击编辑按钮
    handleChangeEdit: function handleChangeEdit() {
      this.$emit('onChangeEdit');
      this.loading = false;
    },
    getLabelarr: function getLabelarr(attr) {
      this.labelarr = attr;
    },
    onChange: function onChange(id) {
      this.dataForm.handlingFee = this.merchantClassify.find(function (item) {
        return item.id === id;
      }).handlingFee;
    },
    // 详情
    onInfo: function onInfo() {
      var _this3 = this;
      if (!this.merchantClassify.length) this.$store.dispatch('merchant/getMerchantClassify');
      if (!this.merchantType.length) this.$store.dispatch('merchant/getMerchantType');
      this.loadingFrom = true;
      merchant.merchantDetailApi(this.merId).then(function (res) {
        _this3.$set(res, 'sliderImages', res.qualificationPicture ? JSON.parse(res.qualificationPicture) : []);
        _this3.dataForm = res;
        _this3.labelarr = res.keywords.split(',') || [];
        _this3.loadingFrom = false;
      });
    },
    // 点击商品图
    modalPicTap: function modalPicTap(multiple) {
      var _this = this;
      this.$modalUpload(function (img) {
        if (!img) return;
        if (img.length > 10) return this.$message.warning('最多选择10张图片！');
        if (img.length + _this.dataForm.sliderImages.length > 10) return this.$message.warning('最多选择10张图片！');
        img.map(function (item) {
          _this.dataForm.sliderImages.push(item.sattDir);
        });
      }, multiple, 'store');
    },
    handleRemove: function handleRemove(i) {
      this.dataForm.sliderImages.splice(i, 1);
    },
    // 取消
    handleClose: function handleClose() {
      var _this4 = this;
      if (this.merId > 0) {
        if (this.handleType === 'edit') {
          this.$emit('closeModel');
        } else {
          this.onInfo();
          this.handleChangeEdit();
        }
      } else {
        this.$nextTick(function () {
          _this4.$refs['dataForm'].resetFields();
        });
        this.$emit('closeModel');
      }
    },
    // 编辑、添加回调
    onClose: function onClose() {
      this.$refs['dataForm'].resetFields();
      this.$emit('getList');
      this.loading = false;
    },
    buildSubmitPayload: function buildSubmitPayload() {
      return {
        id: this.dataForm.id,
        name: this.dataForm.name,
        account: this.dataForm.account,
        phone: this.dataForm.phone,
        realName: this.dataForm.realName,
        categoryId: this.dataForm.categoryId,
        handlingFee: this.dataForm.handlingFee,
        typeId: this.dataForm.typeId,
        isRecommend: this.dataForm.isRecommend,
        isSelf: this.dataForm.isSelf,
        isSwitch: this.dataForm.isSwitch,
        showShop: this.dataForm.showShop,
        productSwitch: this.dataForm.productSwitch,
        keywords: this.labelarr.join(','),
        qualificationPicture: JSON.stringify(this.dataForm.sliderImages),
        remark: this.dataForm.remark,
        sort: this.dataForm.sort,
        starLevel: this.dataForm.starLevel
      };
    },
    onsubmit: function onsubmit(formName) {
      var _this5 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this5.loading = true;
          var submitData = _this5.buildSubmitPayload();
          _this5.dataForm.id === 0 ? merchant.merchantAddApi(submitData).then(function (res) {
            _this5.$message.success("\u6DFB\u52A0\u5546\u6237\u6210\u529F");
            _this5.onClose();
          }).catch(function () {
            _this5.loading = false;
          }) : merchant.merchantUpdateApi(submitData).then(function (res) {
            _this5.$message.success('操作成功');
            if (_this5.handleType === 'edit') {
              _this5.onClose();
            } else {
              _this5.onInfo();
              _this5.handleChangeEdit();
            }
          }).catch(function () {
            _this5.loading = false;
          });
        } else {
          return false;
        }
      });
    },
    // 移动
    handleDragStart: function handleDragStart(e, item) {
      this.dragging = item;
    },
    handleDragEnd: function handleDragEnd(e, item) {
      this.dragging = null;
    },
    handleDragOver: function handleDragOver(e) {
      e.dataTransfer.dropEffect = 'move';
    },
    handleDragEnter: function handleDragEnter(e, item) {
      e.dataTransfer.effectAllowed = 'move';
      if (item === this.dragging) {
        return;
      }
      var newItems = _toConsumableArray(this.dataForm.sliderImages);
      var src = newItems.indexOf(this.dragging);
      var dst = newItems.indexOf(item);
      newItems.splice.apply(newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
      this.dataForm.sliderImages = newItems;
    }
  }
};